import storage, { keys } from '~/services/storage'
import { getRouteAccess } from '~/constants/routeAccess'
import { decryptSessionPayload } from '~/services/sessionCrypto'

const WITHDRAWAL_TYPES = ['WITHDRAWAL']
const REGULAR_ONLY_BLOCKED_TYPES = ['ASSOCIATE', 'WITHDRAWAL']
// localStorage/sessionStorage에 저장할 path 보정
function getSafePath(path = '/') {
  return typeof path === 'string' && path && !/undefined\b/.test(path) ? path : '/'
}
// 현재 접근 경로 저장
function savePathInfo(fullPath = '/') {
  storage.set(keys.pathInfo, getSafePath(fullPath))
}
// 공통 alert 표시 함수
function showAlert(store, content) {
  try {
    store.dispatch('modal/SHOW_ALERT', { content })
  } catch (e) {}
}
// 회원 타입 추출 함수
function getMemberType(member) {
  return String(member?.type || member?.memberType || '').toUpperCase()
}
// 서버 세션 조회
async function fetchSession($axios) {
  try {
    const payload = await $axios.$post('member/session', {})
    const encrypted =
      payload?.data?.session ||
      payload?.session ||
      null

    if (!encrypted) return null

    const session = decryptSessionPayload(encrypted)

    if (!session || !session.id) return null

    return session
  } catch (e) {
    const errorCode = e?.response?.data?.error
    if (errorCode === 'INVALID_SESSION') return null
    console.error('fetchSession error', e)
    return null
  }
}
// Nuxt 전역 auth middleware
export default async function ({ route, store, redirect, $axios }) {
  const toPath = route.path || '/'
  const fullPath = route.fullPath || toPath
  const access = getRouteAccess(toPath)
  const NO_SAVE_PATHS = ['/', '/Login', '/SignUp']
  // /, /Login, /SignUp 는 pathInfo 저장 안 함
  if (!NO_SAVE_PATHS.includes(toPath) && access !== 'guestOnly') {
    savePathInfo(fullPath)
  }

  // public 경로는 누구나 접근
  if (access === 'public') {
    return
  }

  // guestOnly / member / regular 는 무조건 서버 세션 기준
  const session = await fetchSession($axios)

  // UI 동기화용으로만 store 반영
  if (session?.id) {
    await store.dispatch('member/SET_SESSION_INFO', session)
  } else {
    await store.dispatch('member/CLEAR_SESSION_INFO')
    await store.dispatch('member/CLEAR_MEMBER_INFO')
  }

  // 로그인/회원가입 페이지는 로그인 상태면 접근 불가
  if (access === 'guestOnly') {
    if (session?.id) {
      return redirect('/')
    }
    return
  }

  // 보호 페이지는 비로그인 차단
  if (!session?.id) {
    showAlert(store, '로그인이 필요합니다.')
    return redirect('/Login')
  }

  const currentType = getMemberType(session)

  // 탈퇴 회원 차단
  if (WITHDRAWAL_TYPES.includes(currentType)) {
    showAlert(store, '탈퇴 또는 사용 불가 상태의 회원입니다.')
    return redirect('/')
  }

  // 준회원 + 정회원 허용 경로
  if (access === 'member') {
    return
  }

  // 정회원 전용 경로
  if (REGULAR_ONLY_BLOCKED_TYPES.includes(currentType)) {
    showAlert(store, '정회원 전용 서비스입니다.')
    return redirect('/')
  }
}